import "../../styles/pages/Adm/global.adm.styles.css"
import { ButtonCenter } from "../../components/adm/ButtonCenter"
import { Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { fetchGetData } from "../../../lib/fetchGetData"
import { fetchDeleteData } from "../../../lib/fetchDeleteData"
import { FaPen } from "react-icons/fa"
import { FaTrash } from "react-icons/fa"

export const Services = () => {
    const [servicesData, setServicesData] = useState([])

    useEffect(() => {
        async function fetchData() {
            let data = await fetchGetData("services")
            setServicesData(data)
        }
        fetchData()
    }, [])

    function handleDeleteData(props) {
        let response = window.confirm("Tem certeza de que deseja excluir?")
        if (response) {
            try {
                fetchDeleteData(props)
            } catch (error) {
                alert("Erro:", error)
                return
            }
            setServicesData(servicesData.filter(banner => banner.id !== props.id))
            alert("Excluido")
        }
    }

    const RenderServices = () => {

        const RenderService = (props) => {
            let { name, id, shortDescrip, longDescrip, imgHome, imgPage, position } = props
            return (
                <div className="service-box-adm">
                    <div className="img-box">
                        <img src={imgHome} alt="Imagem" />
                        <img src={imgPage} alt="Imagem" />
                    </div>
                    <div className="data-box">
                        <p>{name}</p>
                        <p>Posição: {position}</p>
                        <p><span>Texto da Home:</span> {shortDescrip}</p>
                        <p><span>Texto da Page:</span> {longDescrip}</p>
                    </div>
                    <div className="btns-box">
                        <Link to={`/admin/servicos/editar/${id}`}>
                            <FaPen />
                        </Link>
                        <button onClick={() => handleDeleteData({
                            collectionName: "services",
                            id: id,
                            imgLink: imgHome,
                            imgLink2: imgPage
                        })}>
                            <FaTrash />
                        </button>
                    </div>
                </div>
            )
        }

        return (
            <>
                {servicesData.map((service) => (
                    <RenderService
                        key={service.id}
                        id={service.id}
                        name={service.name}
                        shortDescrip={service.shortDescrip}
                        longDescrip={service.longDescrip}
                        imgHome={service.imgHome}
                        imgPage={service.imgPage}
                        position={service.position}
                    />
                ))}
            </>
        )
    }

    return (
        <>
            <ButtonCenter
                homeBtn={true}
            />
            <div className="div-adm">
                <Link className="link-add" to={"/admin/servicos/add"}> Adicionar Serviço </Link>
                <div className="container-itens">
                    <RenderServices />
                </div>
            </div>
        </>
    )
}